<template>
  <div id="role">
    <base-header class="bg-primary pb-6 pt-0">
      <div class="row align-items-center pb-2">
        <div class="col-lg-6 col-7">
          <breadcrumb
            :link="[
              { name: 'Cài đặt' },
              { name: 'Quản lý quyền', active: true }
            ]"
          ></breadcrumb>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6 bg-lighter">
      <block ref="brole" class="control-box">
        <b-row>
          <b-col sm="4">
            <b-list-group>
              <template v-for="(item, index) in arrRole">
                <b-list-group-item
                  :key="index"
                  :class="{ active: item.id == roleSelected.id }"
                  @click="doSelectRole(index)"
                  class="d-flex justify-content-between align-items-center"
                >
                  <div>
                    <h6>{{ item.name }}</h6>
                    <span>{{ item.description }}</span>
                  </div>
                  <b-button @click="btnEditRoleClick(item)" variant="info"
                    ><i class="fa fa-edit"></i
                  ></b-button>
                </b-list-group-item>
              </template>
              <b-list-group-item>
                <b-button block @click="btnNewRoleClick"
                  >Thêm mới Nhóm Quyền (A)</b-button
                >
              </b-list-group-item>
            </b-list-group>
          </b-col>
          <b-col sm="8">
            <block ref="bfeature">
              <b-card
                class="mb-3"
                no-body
                v-for="(item, index) in roleSelected.groups"
                :key="index"
              >
                <b-card-header
                  header-tag="header"
                  class="p-1 d-flex justify-content-between align-items-center"
                >
                  <b-button variant="link" href="#" v-b-toggle="item.key">
                    <span>{{ item.name }}</span>
                  </b-button>
                  <b-button
                    @click="btnEditFeatureGroupClick(item, $event)"
                    pill
                    variant="outline-secondary"
                    size="sm"
                    ><i class="fas fa-edit"></i
                  ></b-button>
                </b-card-header>
                <b-collapse visible :id="item.key">
                  <b-card-body class="px-5">
                    <b-row>
                      <b-col
                        sm="4"
                        class="mb-2"
                        v-for="(feature, index) in item.features"
                        :key="index"
                      >
                        <div class="d-flex align-items-center">
                          <b-checkbox
                            variant="success"
                            switch
                            @change="
                              updateAccessFeature(feature, roleSelected, $event)
                            "
                            value="1"
                            v-model="feature.rule.access"
                          >
                            {{ feature.name }}
                          </b-checkbox>
                          <i
                            class="fas fa-edit ml-2"
                            @click="btnEditFeatureClick(feature)"
                          ></i>
                        </div>
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </block>
          </b-col>
        </b-row>
      </block>
      <role-modal @submit:success="getListRole" ref="modalRole"></role-modal>
      <feature-group-modal
        @submit:success="getListRole"
        ref="modalFeatureGroup"
      ></feature-group-modal>
      <feature-modal
        @submit:success="getListRole"
        ref="modalFeature"
      ></feature-modal>
      <event @doAdd="btnNewRoleClick"></event>
    </div>
  </div>
</template>
<script>
import { roleService } from "@/_services";
import RoleModal from "./RoleModal";
import FeatureGroupModal from "./FeatureGroupModal";
import FeatureModal from "./FeatureModal";
export default {
  name: "role-manage",
  data() {
    return {
      arrRole: [],
      roleSelected: {},
      listRoleActive: 0,
      modal_title: "",
      check: true,
      roleObj: {},
      roleObjTmp: {},
      ruleObj: {},
      ruleObjTmp: {},
      groupRuleObj: {},
      groupRuleObjTmp: {}
    };
  },
  components: {
    RoleModal,
    FeatureGroupModal,
    FeatureModal
  },
  computed: {},
  mounted() {
    this.getListRole();
  },
  methods: {
    getListRole() {
      this.$refs.brole.block();
      roleService
        .getlist()
        .then(res => {
          this.arrRole = res.data;
          this.arrRole.forEach(element => {
            element.groups.forEach(groups => {
              groups.features.forEach(feature => {
                if (!feature.rule) {
                  feature.rule = { access: 0 };
                }
              });
            });
          });
          this.doSelectRole(0);
        })
        .finally(() => {
          this.$refs.brole.unBlock();
        });
    },
    updateAccessFeature(feature, role, $e) {
      this.$refs.bfeature.block();
      if ($e == false) $e = 0;
      else if ($e == true) $e = 1;
      let rule = feature.rule;
      rule.access = $e;
      roleService
        .access(rule, role.id, feature.id)
        .then(res => {
          console.log(res);
          this.$alertify.success(res.message, {
            duration: 4000
          });
        })
        .catch(() => {
          feature.rule.access = $e ? 0 : 1;
        })
        .finally(() => {
          this.$refs.bfeature.unBlock();
        });
    },
    doSelectRole(index) {
      this.listRoleActive = index;
      this.roleSelected = this.arrRole[index];
    },
    btnNewRoleClick() {
      this.$refs.modalRole.visible = true;
      this.$refs.modalRole.setData({});
    },
    btnEditRoleClick(item) {
      this.$refs.modalRole.visible = true;
      this.$refs.modalRole.setData(item);
    },
    btnEditFeatureGroupClick(item) {
      console.log(item);
      this.$refs.modalFeatureGroup.visible = true;
      this.$refs.modalFeatureGroup.setData(item);
    },
    btnEditFeatureClick(item) {
      console.log(item);
      this.$refs.modalFeature.visible = true;
      this.$refs.modalFeature.setData(item);
    }
  }
};
</script>
<style lang="scss">
.list-group-item {
  cursor: pointer;
}
#role {
  .card {
    margin-bottom: 0px;
  }
}
#role {
  .card {
    .card-header {
      padding-top: 10px;
      padding-bottom: 10px;
    }
  }
}
#role {
  .card {
    .card-body {
      .list-group-item {
        padding-top: 15px !important;
        padding-bottom: 15px !important;
      }
    }
  }
}
#role {
  .card {
    .active {
      .role_description {
        color: #adb5bd;
      }
    }
  }
}
#role {
  .card {
    .active {
      .role_title {
        color: white;
      }
    }
  }
}
</style>
